/**
 * @fileoverview 管理功能实例的添加、删除和清除操作
 */

/**
 * @constant {Set} FUNCTIONAL_INSTANCE_LIST - 用于存储功能实例的集合
 */
const FUNCTIONAL_INSTANCE_LIST = new Set();

/**
 * 如果实例不存在，则将新的功能实例添加到集合中
 * @function addFunctionalInstance
 * @param {Object} instance - 要添加的功能实例
 */
export const addFunctionalInstance = instance => {
  !FUNCTIONAL_INSTANCE_LIST.has(instance) && FUNCTIONAL_INSTANCE_LIST.add(instance);
};

/**
 * 从集合中移除功能实例并销毁它
 * @function deleteFunctionalInstance
 * @param {Object} instance - 要删除的功能实例
 * @returns {void}
 */
export const deleteFunctionalInstance = instance => {
  if (!FUNCTIONAL_INSTANCE_LIST.has(instance)) return;

  FUNCTIONAL_INSTANCE_LIST.delete(instance);

  instance?.$destroy();
};

/**
 * 清除集合中的所有功能实例
 * @function clearFunctionalInstance
 * @returns {void}
 */
export const clearFunctionalInstance = () => {
  FUNCTIONAL_INSTANCE_LIST.forEach(value => {
    deleteFunctionalInstance(value);
  });

  FUNCTIONAL_INSTANCE_LIST.clear();
};
